import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import AccountingTab from "./AccountingTab";
import AccountingSubModules from "./AccountingSubModules";

const accountingTabPaths = [
  // 'dashboard',
  "invoices",
  "reports",
  // "settings", // Moved to accountingSubModulePaths for standalone page
  "actions-history",
  "aspire",
  "chart-of-accounts",
];

// New sub-module paths
const accountingSubModulePaths = [
  "sales-dashboard",
  "reports-list",
  "financial-reports",
  "accounts-payable",
  "accounts-receivable",
  "transactions-allocations",
  "advance-accounting",
  "letter-processing-records",
  "settings",
];

const AccountingRoutes = () => {
  return (
    <Routes>
      {/* Root accounting path - redirect to reports-list */}
      <Route path="" element={<Navigate to="/accounting/reports-list" replace />} />

      {/* Regular Accounting Tabs - Keep original functionality */}
      {accountingTabPaths.map((tab) => (
        <Route key={tab} path={tab} element={<AccountingTab />} />
      ))}

      {/* Payment Allocation dynamic route */}
      <Route path="payment-allocation/:subTab" element={<AccountingTab />} />

      {/* New Sub-modules - Additional functionality */}
      {accountingSubModulePaths.map((subModule) => (
        <Route
          key={subModule}
          path={subModule}
          element={<AccountingSubModules />}
        />
      ))}

      {/* Fallback to original accounting */}
      <Route path="*" element={<AccountingTab />} />
    </Routes>
  );
};

export default AccountingRoutes;
